import React, { useState, useEffect } from 'react';
import { containerOne, btnOne, containerTwo, title, subTitle, btnSmall, btnWhite, errorText, btnRound } from "../utils/style";
import OtpInput from 'react-otp-input';
import backArrow from '../assets/icons/arrow_black.png';

function OtpScreen({ otp, setOtp, email, error, login, getOtp, setLoginScreen }) {
    const [timer, setTimer] = useState(60); // 1-minute timer
    const [isTimerRunning, setIsTimerRunning] = useState(true);

    useEffect(() => {
        let interval;
        if (isTimerRunning && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000); // Decrement every second
        } else if (timer === 0) {
            clearInterval(interval);
        }
        
        return () => clearInterval(interval); // Cleanup the interval
    }, [timer, isTimerRunning]);

    const handleResendOtp = () => {
        getOtp();
        setTimer(60); // Reset timer when resending OTP
        setIsTimerRunning(true); // Start the timer again
    };

    return (
        <div className={containerTwo}>
            <div className="basis-2/3">
                <div className="text-xl mb-2 font-bold">Check Your Email Address</div>
                <p className="mb-4 text-[16px]">We sent a verification code to <span className='underline font-bold'>{email}</span></p>
                <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    containerStyle={'flex justify-between gap-4'}
                    inputType="number"
                   
                    inputStyle={'text-black flex-1 bg-customTwo outline-none border-none rounded-md py-4'}
                    renderInput={(props) => <input {...props} 
                   
                    />}
                />
               
                {
                    error && <div className={errorText}>{error}</div>
                }
                <div className="text-center text-customOne text-sm py-2">
                    {timer > 0 ? 
                    <p>
                        Resend in <b className=''>{timer}s</b>
                    </p>
                    
                     :  <div className={'text-center text-customOne text-sm py-2'} onClick={handleResendOtp}>
                    Didn't receive the code? <b>Click to resend</b>
                </div>}
                </div>
            </div>
            <div className="py-2 basis-1/3 flex justify-between pb-12">
                <div className="flex justify-between items-center py-2 w-full">
                    <button className={btnRound} onClick={() => setLoginScreen(true)}>
                        <img src={backArrow} height={20} width={20} />
                    </button>
                    <button className={btnSmall} onClick={() => login()}>Next</button>
                </div>
            </div>
        </div>
    );
}

export default OtpScreen;
